import React from 'react';

export default class ChoroplethPattern extends React.Component {
  constructor(props) {
    super(props);
  };
  
  arrToRGB(colorArr) {
    return `rgb(${colorArr})`;
  };
  
  getBackgroundColor() {
    return this.arrToRGB(this.props.backgroundColor);
  };
  
  getPatternColor() {
    return this.arrToRGB(this.props.patternColor)
  };
}
